import React from "react";
import SingleSelector from "@/components/SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const TemplateList = React.forwardRef(
  (
    { disabled, name, value, onChange, clearable, className, data = [], style },
    ref
  ) => {
    const { t } = useTranslation();

    return (
      <SingleSelector
        placeholder={t({ defaultMessage: "选择模板" })}
        options={data.map(item => ({
          id: item.templateId,
          name: item.templateName
        }))}
        clearable={clearable}
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        className={className}
        style={{ width: 180, ...style }}
      />
    );
  }
);

export default TemplateList;
